// Shared helpers for Quote/Invoice list, form, and view components.
// Keeps status labels/badges and money formatting consistent across all six.

export function formatMoney(amount, currency) {
    const n = Number(amount || 0);
    const formatted = n.toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return currency ? `${currency} ${formatted}` : formatted;
}

// This app's UI convention restricts badge/text colors to primary, danger,
// secondary, and dark only — no success/warning/info — so status meaning is
// carried by primary (good/complete), dark (in progress), secondary (neutral/
// inactive), and danger (needs attention) rather than a wider palette.
export const QUOTE_STATUSES = {
    draft: { label: 'Draft', badge: 'badge-secondary' },
    sent: { label: 'Sent', badge: 'badge-dark' },
    accepted: { label: 'Accepted', badge: 'badge-primary' },
    converted: { label: 'Converted', badge: 'badge-primary' },
    expired: { label: 'Expired', badge: 'badge-secondary' },
    cancelled: { label: 'Cancelled', badge: 'badge-danger' },
};

export const INVOICE_STATUSES = {
    unpaid: { label: 'Unpaid', badge: 'badge-secondary' },
    partial: { label: 'Partially Paid', badge: 'badge-dark' },
    paid: { label: 'Paid', badge: 'badge-primary' },
    overdue: { label: 'Overdue', badge: 'badge-danger' },
    cancelled: { label: 'Cancelled', badge: 'badge-secondary' },
};

export function quoteStatusMeta(status) {
    return QUOTE_STATUSES[status] || { label: status || 'Draft', badge: 'badge-secondary' };
}

export function invoiceStatusMeta(status) {
    return INVOICE_STATUSES[status] || { label: status || 'Unpaid', badge: 'badge-secondary' };
}

// A business customer's document should be addressed to the business, not
// whichever contact person happens to be on file for it - `customer.company`
// is the business/company name field on the Customers model. Individual
// customers (no company on file) keep showing their personal name.
export function customerLabel(customer) {
    if (!customer) return 'Walk-in customer';
    return customer.company || customer.full_name || 'Walk-in customer';
}

// The contact person, shown as a secondary "Attn:" line only when there's
// also a business name being shown as the primary label above it.
export function customerAttnLine(customer) {
    if (!customer) return '';
    return customer.company && customer.full_name ? customer.full_name : '';
}

export function apiErrorMessage(error, fallback) {
    const data = error && error.response && error.response.data;
    if (data && data.message) return data.message;
    if (data && data.errors) {
        const first = Object.values(data.errors)[0];
        if (Array.isArray(first) && first.length) return first[0];
    }
    return fallback || 'Something went wrong. Please try again.';
}
